import { render, staticRenderFns } from "./PanelEconomicModal.vue?vue&type=template&id=36bb3c38"
import script from "./PanelEconomicModal.vue?vue&type=script&lang=js"
export * from "./PanelEconomicModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports